function setRunAs(email, skip) {
  if (!email) {
    localStorage.removeItem("run-as-email");
  }
  localStorage.setItem("run-as-email", email);
  if (skip) {
    return;
  }
  window.location.href = "/";
}

function getRunAs() {
  return localStorage.getItem("run-as-email");
}

function setReportingCompany(companyId, companyName) {
  if (!companyId) {
    localStorage.removeItem("reporting-company-id");
    localStorage.removeItem("reporting-company-name");
  } else {
    localStorage.setItem("reporting-company-id", companyId);
    localStorage.setItem("reporting-company-name", companyName);
  }
}

function getReportingCompany() {
  return localStorage.getItem("reporting-company-id");
}

function getReportingCompanyName() {
  return localStorage.getItem("reporting-company-name");
}

export {
  getRunAs,
  setRunAs,
  getReportingCompany,
  setReportingCompany,
  getReportingCompanyName
};
